import { Injectable, OnDestroy } from '@angular/core';
import { AbstractCRUDService } from '@campaign-portal/components-library';
import { EntityField, InputType } from '@campaign-portal/namespace/common/entityField';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CurrenciesFieldsService implements AbstractCRUDService, OnDestroy {
	readonly name: EntityField = {
		id: 0,
		name: 'currencies.name',
		variable: 'name',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly currencySymbol: EntityField = {
		id: 1,
		name: 'currencies.symbol',
		variable: 'currencySymbol',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	
	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly headers: EntityField[] = [
		this.name,
		this.currencySymbol
	];
	
	constructor() {
	}
	
	ngOnDestroy(): void {
		this.loading$.complete();
	}
	
	read(): Observable<ReadResponse<EntityField[]>> {
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});
	
	}
	
	create(): Observable<void> {
		return of();
	}
	
	update(): Observable<void> {
		return of();
	}
	
	delete(): Observable<void> {
		return of();
	}
}
